import React, {memo} from 'react';

import './FooterSocialList.less';

function FooterSocialList() {
  return (
    <div className="footer-item footer-social">
      <ul className="footer-social list-inline">
        <li className="footer-social-item">
          <a
            href="https://www.instagram.com/mynewjob.pro/"
            className="footer-social-link inst"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="16" height="16">
              <defs>
                <clipPath id="footer-inst-icon">
                  <rect x="-1764" y="-954" width="1920" height="990" clipRule="evenodd" />
                </clipPath>
              </defs>
              <g clipPath="url(#footer-inst-icon)">
                <path
                  stroke="none"
                  d="M11.6689 0L4.33105 0C1.94287 0 0 1.94287 0 4.33105L0 11.6691C0 14.0571 1.94287 16 4.33105 16L11.6691 16C14.0571 16 16 14.0571 16 11.6691L16 4.33105C16 1.94287 14.0571 0 11.6689 0ZM11.1868 3.36414C11.1868 4.07703 11.7666 4.65686 12.4795 4.65686C13.1924 4.65686 13.7723 4.07703 13.7723 3.36414C13.7723 2.65125 13.1924 2.07129 12.4795 2.07129C11.7666 2.07129 11.1868 2.65125 11.1868 3.36414ZM8 12.3749C5.58765 12.3749 3.62512 10.4124 3.62512 8C3.62512 5.58765 5.58765 3.62512 8 3.62512C10.4124 3.62512 12.3749 5.58765 12.3749 8C12.3749 10.4124 10.4124 12.3749 8 12.3749Z"
                  fillRule="evenodd"
                />
              </g>
            </svg>
          </a>
        </li>
        <li className="footer-social-item">
          <a
            href="https://www.facebook.com/mynewjob.pro"
            className="footer-social-link fb"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="10" height="16">
              <defs>
                <clipPath id="footer-fb-icon">
                  <rect x="-1803" y="-954" width="1920" height="990" clipRule="evenodd" />
                </clipPath>
              </defs>
              <g clipPath="url(#footer-fb-icon)">
                <path
                  stroke="none"
                  d="M9.62343 0.00332907L7.22488 0C4.5302 0 2.78878 1.54552 2.78878 3.93762L2.78878 5.75313L0.377148 5.75313C0.168754 5.75313 0 5.89927 0 6.07954L0 8.71001C0 8.89028 0.168947 9.03626 0.377148 9.03626L2.78878 9.03626L2.78878 15.6738C2.78878 15.854 2.95753 16 3.16593 16L6.31242 16C6.52081 16 6.68957 15.8539 6.68957 15.6738L6.68957 9.03626L9.50932 9.03626C9.71772 9.03626 9.88647 8.89028 9.88647 8.71001L9.88763 6.07954C9.88763 5.99299 9.84779 5.91009 9.77717 5.84884C9.70656 5.78758 9.61034 5.75313 9.51029 5.75313L6.68957 5.75313L6.68957 4.2141C6.68957 3.47438 6.89334 3.09886 8.00727 3.09886L9.62304 3.09836C9.83125 3.09836 10 2.95222 10 2.77211L10 0.329578C10 0.149642 9.83144 0.00366197 9.62343 0.00332907Z"
                />
              </g>
            </svg>
          </a>
        </li>
        <li className="footer-social-item">
          <a
            href="https://vk.com/mynewjobpro"
            className="footer-social-link vk"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="22" height="14">
              <defs>
                <clipPath id="footer-vk-icon">
                  <rect x="-1833" y="-956" width="1920" height="990" clipRule="evenodd" />
                </clipPath>
              </defs>
              <g clipPath="url(#footer-vk-icon)">
                <path
                  stroke="none"
                  d="M18.6226 8.88511C19.3404 9.6848 20.098 10.4372 20.7417 11.3175C21.0261 11.7087 21.2953 12.1124 21.5013 12.5664C21.7931 13.2118 21.5288 13.922 21.0217 13.9605L17.8694 13.9589C17.0564 14.0359 16.4078 13.6624 15.8624 13.0281C15.426 12.5208 15.0218 11.9808 14.6021 11.4564C14.4301 11.2421 14.25 11.0404 14.0349 10.881C13.6046 10.5622 13.231 10.6598 12.9851 11.172C12.7347 11.6929 12.6779 12.2697 12.6533 12.8503C12.6195 13.6974 12.3951 13.9201 11.6495 13.9588C10.056 14.0446 8.54369 13.7695 7.13881 12.8522C5.90021 12.0435 4.93974 10.9018 4.10375 9.60935C2.47606 7.09264 1.22957 4.32719 0.10928 1.48426C-0.14289 0.843744 0.0415273 0.499918 0.660824 0.487749C1.68919 0.464951 2.71742 0.466574 3.747 0.486126C4.16496 0.493103 4.44166 0.766671 4.60304 1.21726C5.15942 2.77843 5.84021 4.26374 6.69476 5.64051C6.92233 6.00705 7.15438 6.37359 7.48482 6.63158C7.85038 6.91724 8.12872 6.82256 8.30069 6.35785C8.40982 6.06319 8.45759 5.74581 8.48219 5.43022C8.56367 4.34447 8.5744 3.26058 8.4315 2.17864C8.34377 1.50341 8.01049 1.06628 7.42005 0.938503C7.11876 0.873356 7.16362 0.745415 7.3095 0.549163C7.56288 0.210693 7.80119 0 8.27624 0L11.8388 0C12.3997 0.126318 12.5242 0.41384 12.601 1.05784L12.6041 5.57374C12.5979 5.82305 12.7132 6.56287 13.1067 6.72788C13.4216 6.84536 13.6292 6.55783 13.8182 6.32994C14.6712 5.29684 15.28 4.07593 15.8238 2.81169C16.0652 2.2558 16.2727 1.67848 16.4738 1.10165C16.6228 0.673616 16.8567 0.463004 17.2792 0.472334L20.708 0.475823C20.8096 0.475823 20.9125 0.477526 21.011 0.496754C21.5887 0.609118 21.7471 0.892746 21.5686 1.53659C21.2874 2.54673 20.7404 3.38852 20.2055 4.23421C19.6337 5.1371 19.0221 6.00908 18.4551 6.91732C17.9341 7.7467 17.9755 8.16476 18.6226 8.88511L18.6226 8.88511Z"
                />
              </g>
            </svg>
          </a>
        </li>
        <li className="footer-social-item">
          <a
            href="https://www.youtube.com/channel/UCh91OLGsouQrCgQpiRDjOuw"
            className="footer-social-link yt"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg width="20" height="14">
              <defs>
                <clipPath id="footer-youtube-icon">
                  <rect x="-1879" y="-956" width="1920" height="990" clipRule="evenodd" />
                </clipPath>
              </defs>
              <g clipPath="url(#footer-youtube-icon)">
                <path
                  stroke="none"
                  d="M13.2954 7C11.5439 5.99725 9.80408 5.00092 8.0549 3.99992L8.0549 10.0001C9.80467 8.9985 11.5439 8.00275 13.2954 7M9.14066 0L10.9374 0C10.9608 0.00291667 10.9837 0.00875 11.0066 0.00933333C11.5163 0.0175 12.0266 0.0221667 12.537 0.0344167C13.1042 0.04725 13.672 0.0600833 14.238 0.08575C14.9144 0.117833 15.5901 0.158667 16.2647 0.204167C16.7662 0.238 17.2671 0.282333 17.7575 0.392C18.7271 0.609 19.3759 1.18942 19.678 2.13092C19.8381 2.63025 19.8938 3.15233 19.9519 3.6715C19.9666 3.80508 19.9836 3.93808 20 4.07108L20 9.86708C19.9836 9.99717 19.966 10.1273 19.9531 10.2573C19.9026 10.7625 19.8451 11.2671 19.7132 11.7577C19.4539 12.7213 18.8362 13.3426 17.8643 13.5969C17.3921 13.7206 16.9052 13.7603 16.4201 13.7917C15.5402 13.8483 14.6592 13.8985 13.7776 13.9318C12.9165 13.9638 12.0548 13.9691 11.1937 13.9878C11.1186 13.9889 11.0435 13.9953 10.9684 14L9.18759 14C9.15943 13.9965 9.13069 13.9913 9.10312 13.9907C8.33001 13.9755 7.5569 13.9726 6.78437 13.9428C5.80948 13.9061 4.83517 13.8518 3.86145 13.7952C3.35817 13.7661 2.85371 13.7188 2.36098 13.6074C1.34503 13.3782 0.681605 12.7628 0.408846 11.76C0.208236 11.0227 0.148991 10.2626 0.0991319 9.50367C0.0574847 8.86375 0.0398874 8.2215 0.0117316 7.581C0.0105584 7.55008 0.00410605 7.51975 0 7.48942L0 6.51058C0.00410605 6.47733 0.0117316 6.44467 0.0117316 6.412C0.0299155 5.54458 0.0703895 4.67892 0.157203 3.81617C0.209995 3.28067 0.264547 2.74342 0.411779 2.22483C0.679259 1.281 1.29047 0.662667 2.2466 0.404833C2.71997 0.277667 3.21035 0.242083 3.69779 0.207667C4.43512 0.156917 5.17245 0.11025 5.91096 0.084C6.88351 0.049 7.85723 0.0361667 8.82977 0.0134167C8.93301 0.0110833 9.03684 0.00466667 9.14066 0"
                />
              </g>
            </svg>
          </a>
        </li>
      </ul>
    </div>
  );
}

export default memo(FooterSocialList);
